import { injectReducers } from '../../store/reducers'
import AppLayout from '../../components/Layouts/AppLayout'
import { AsyncComponent } from '../../components/Layouts/RouterLayout'
import * as ROUTES from '../../constants/routes'

const getDistrictContainer = store =>
  import(/* webpackChunkName: "Message" */ './reducers')
    .then(module => injectReducers(store, module.default))
    .then(() => import(/* webpackChunkName: "Message" */ './containers/DistrictContainer'))
    .then(module => module.default)

export default (store) => ([
  {
    layout: AppLayout,
    exact: true,
    path: [
      ROUTES.DISTRICT_LIST_PATH
    ],
    component: AsyncComponent(() => getDistrictContainer(store))
  }
])
